var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticStyle:{"max-width":"100%"}},[_c('div',{staticClass:"title text-center"},[_vm._v("Tee Time Management")]),_c('tee-time-show',{on:{"update:teeTimeSaved":function($event){return _vm.handleTeeTimeSave()}}}),_c('transaction-index',{attrs:{"update-counter":_vm.updateCounter,"type":"TeeTime"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }